import { DeadLetterDetail } from '../../domain/models/DeadLetterDetail';
import { DeadLetterRepository } from '../../domain/ports/DeadLetterRepository';
import { DeadLetterMessage } from '../../domain/models/DeadLetterMessage';

export class DeadLetterService {
  constructor(private deadLetterRepository: DeadLetterRepository) {}

  async getAll(): Promise<DeadLetterMessage[]> {
    try {
      return await this.deadLetterRepository.getAll();
    } catch (error) {
      console.error('DeadLetterService: Failed to get dead letter messages', error);
      throw error;
    }
  }

  async show(id: number): Promise<DeadLetterDetail> {
    try {
      return await this.deadLetterRepository.show(id);
    } catch (error) {
      console.error('DeadLetterService: Failed to fetch dead letter message details', error);
      throw error;
    }
  }

  async retry(id: number): Promise<void> {
    try {
      await this.deadLetterRepository.retry(id);
    } catch (error) {
      console.error('DeadLetterService: Failed to retry dead letter message', error);
      throw error;
    }
  }

  async remove(id: number): Promise<void> {
    try {
      await this.deadLetterRepository.remove(id);
    } catch (error) {
      console.error('DeadLetterService: Failed to remove dead letter message', error);
      throw error;
    }
  }
}
